export const comments_5159999 = {"data":{"data":[],"links":{}}}